"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const aco = {
    name: 'aco',
    tableType: 'dim',
    idField: 'aco_id',
    grain: [
        '::id',
        '::key',
    ],
    joins: [
        'zip-geo::key',
    ],
    tableGrain: ['!aco'],
    foreignKeys: ['zip-geo::key'],
};
const acoFootprint = {
    name: 'aco-footprint',
    tableType: 'fact',
    grain: [
        'aco::key',
        'zip-geo-monthly::key',
        'year-month::key',
    ],
    tableGrain: [
        '!aco',
        'year_month_key'
    ],
    foreignKeys: [
        'aco::key',
        'zip-geo-monthly::key',
    ],
};
const acoMonthlyNumbers = {
    name: 'aco-monthly-numbers',
    altName: 'aco-monthly',
    tableType: 'fact',
    grain: [
        'year-month::key',
    ],
    tableGrain: ['year_month_key'],
    foreignKeys: ['zip-geo::key'],
};
const basePayment = {
    name: 'base-payment',
    tableType: 'dim',
    idField: 'id',
    grain: [
        '::id',
        '::key',
    ],
    tableGrain: ['!base-payment'],
    foreignKeys: [],
};
const medicareAcoResults = {
    name: 'medicare-aco-results',
    altName: 'mssp-results',
    tableType: 'fact',
    grain: [
        'aco::key',
        'year::key',
    ],
    joins: [
        'payment-arrangement::key',
    ],
    tableGrain: [
        '!aco',
        '!payment-arrangement',
        'year_key'
    ],
    foreignKeys: [
        'payment-arrangement::key',
        'aco::key'
    ],
};
const modifierPayment = {
    name: 'modifier-payment',
    tableType: 'dim',
    idField: 'id',
    grain: [
        '::id',
        'program::key',
    ],
    tableGrain: [
        '!modifier-payment',
        '!program',
    ],
    foreignKeys: [
        'program::key',
    ],
};
const paymentArrangement = {
    name: 'payment-arrangement',
    tableType: 'dim',
    idField: 'id',
    grain: [
        '::id',
        '::key'
    ],
    tableGrain: [
        '!payment-arrangement',
        '!id',
        '!program'
    ],
    foreignKeys: ['program::key'],
    facts: [
        'medicare-aco-results',
        'program',
        'payment-arrangement-footprint'
    ]
};
const paFootprint = {
    name: 'payment-arrangement-footprint',
    tableType: 'fact',
    grain: [
        'payment-arrangement::key',
        'fips',
    ],
    tableGrain: [
        '!payment-arrangement',
        'fips',
    ],
    foreignKeys: [
        'payment_arrangement_dim_key:payment-arrangement::key',
    ]
};
const pioneerResults = {
    name: 'pioneer-results',
    tableType: 'fact',
    grain: [
        'year::key',
        'aco::key',
    ],
    tableGrain: [
        '!aco',
        'year_key',
    ],
    foreignKeys: [
        'aco::key',
    ]
};
const population = {
    name: 'population',
    tableType: 'dim',
    idField: 'population_id',
    grain: [
        '::id',
        '::key',
    ],
    tableGrain: ['!population'],
    foreignKeys: [],
};
const programClassification = {
    name: 'program-classification',
    tableType: 'dim',
    idField: 'id',
    grain: [
        '::id',
        '::key',
        'program::key',
    ],
    tableGrain: ['!program-classification'],
    foreignKeys: [],
};
const program = {
    name: 'program',
    tableType: 'dim',
    idField: 'id',
    grain: [
        '::id',
        '::key',
    ],
    tableGrain: ['!program'],
    foreignKeys: [],
};
const service = {
    name: 'service',
    tableType: 'dim',
    idField: 'service_id',
    grain: [
        '::id',
        '::key',
    ],
    tableGrain: ['!service'],
    foreignKeys: [],
};
const waiver = {
    name: 'waiver',
    tableType: 'dim',
    idField: 'waiver_id',
    grain: [
        '::id',
        '::key',
    ],
    tableGrain: ['!waiver'],
    foreignKeys: [],
};
exports.default = [
    aco,
    acoFootprint,
    acoMonthlyNumbers,
    basePayment,
    medicareAcoResults,
    modifierPayment,
    paymentArrangement,
    paFootprint,
    pioneerResults,
    population,
    programClassification,
    program,
    service,
    waiver,
];
